import {
  BottomSheetContainer,
  Chip,
  createUseBottomSheetModal,
  Flex,
  IconClose,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { useMarketRankingFilterOptions } from '../queries/useMarketRankingFilterOptions';
import { useState } from 'react';

export const useCategoryStyleSelectBottomSheet = createUseBottomSheetModal<
  { nextValue: { category: number | null; style: string[] } },
  {
    selected: { category: number | null; style: string[] };
    marketTypeSno: number;
  }
>(({ confirm, cancel, param }) => {
  const { data } = useMarketRankingFilterOptions(param.marketTypeSno);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(
    param.selected.category,
  );
  const [selectedStyle, setSelectedStyle] = useState<string[]>(
    param.selected.style,
  );

  return (
    <BottomSheetContainer
      title={'필터'}
      onPressClose={cancel}
      titleAlign={'left'}
      hideBorder={true}
      bottomDocked={{
        paired: '1:2',
        type: 'normal',
        button: {
          title: '바로보기',
          onPress: () => {
            confirm({
              nextValue: {
                category: selectedCategory,
                style: selectedStyle,
              },
            });
          },
        },
        pairedButton: {
          title: '초기화',
          onPress: () => {
            setSelectedCategory(null);
            setSelectedStyle([]);
          },
        },
      }}
    >
      <Flex padding={{ horizontal: 16 }} gap={4}>
        <Flex padding={{ vertical: 12 }}>
          <Typography type={'subtitle1'}>카테고리</Typography>
        </Flex>
        <Flex.Row flexWrap={'wrap'} gap={8}>
          <Chip
            size={'medium'}
            onPress={() => {
              setSelectedCategory(null);
            }}
            state={selectedCategory === null ? 'selected' : 'enabled'}
          >
            전체
          </Chip>
          {data.category_options.map(category => (
            <Chip
              size={'medium'}
              onPress={() => {
                setSelectedCategory(category.sno);
              }}
              state={selectedCategory === category.sno ? 'selected' : 'enabled'}
            >
              {category.name}
            </Chip>
          ))}
        </Flex.Row>
      </Flex>

      <VerticalSpacing size={24} />
      <Flex padding={{ horizontal: 16 }} gap={4}>
        <Flex padding={{ vertical: 12 }}>
          <Typography type={'subtitle1'}>스타일</Typography>
        </Flex>
        <Flex.Row flexWrap={'wrap'} gap={8}>
          {data.styles.map(style => {
            const selected =
              selectedStyle.findIndex(
                selectedStyle => selectedStyle === style.value,
              ) !== -1;

            return (
              <Chip
                size={'medium'}
                state={selected ? 'selected' : 'enabled'}
                rightIcon={selected ? <IconClose /> : undefined}
                onPress={() => {
                  setSelectedStyle(prevState => {
                    if (
                      prevState.findIndex(
                        selectedStyle => selectedStyle === style.value,
                      ) !== -1
                    ) {
                      //있는경우
                      return prevState.filter(
                        selectedStyle => selectedStyle !== style.value,
                      );
                    }
                    return [...prevState, style.value];
                  });
                }}
              >
                {style.name}
              </Chip>
            );
          })}
        </Flex.Row>
      </Flex>
    </BottomSheetContainer>
  );
});
